export const DEFAULT_SEARCH_ROWS_PER_PAGE = 10;

const toPositiveInteger = (value, fallback) => {
  const normalized = Number.parseInt(value, 10);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : fallback;
};

const toPageIndex = (value) => {
  const normalized = Number.parseInt(value, 10);
  return Number.isFinite(normalized) && normalized >= 0 ? normalized : 0;
};

export const buildSearchPaginationState = ({
  hasSearchTerm,
  rowsPerPage,
  page,
  searchRowsPerPage = DEFAULT_SEARCH_ROWS_PER_PAGE,
}) => {
  const normalizedSearchRowsPerPage = toPositiveInteger(
    searchRowsPerPage,
    DEFAULT_SEARCH_ROWS_PER_PAGE
  );
  const normalizedRowsPerPage = toPositiveInteger(
    rowsPerPage,
    normalizedSearchRowsPerPage
  );
  const normalizedPage = toPageIndex(page);

  if (hasSearchTerm) {
    return {
      page: 0,
      rowsPerPage: normalizedSearchRowsPerPage,
      limit: normalizedSearchRowsPerPage,
      offSet: 0,
      shouldResetPagination:
        normalizedPage !== 0 ||
        normalizedRowsPerPage !== normalizedSearchRowsPerPage,
    };
  }

  return {
    page: normalizedPage,
    rowsPerPage: normalizedRowsPerPage,
    limit: normalizedRowsPerPage,
    offSet: normalizedRowsPerPage * normalizedPage,
    shouldResetPagination: false,
  };
};
